import React from "react";

const featuresArr = [
  {
    key: "text_1",
    title: "Smart Research Ingestion",
    content: "Valiant makes it effortless to collect and centralize research. Whether you're scraping a webpage, uploading a PDF, or collecting data from open sources, our platform captures it all—complete with automatic citations and contextual tagging. The Chrome extension enables one-click saves and in-browser annotations, making sure nothing important slips through the cracks."
  },
  {
    key: "text_2",
    title: "AI-Driven Analysis",
    content: "Our AI doesn't just summarize—it understands. Valiant delivers paragraph-level summarization with precise citations, keeps you updated on real-time regulatory and market developments, and identifies hidden trends and emerging risks. It's like having a research analyst working 24/7 inside your workflow."
  },
  {
    key: "text_3",
    title: "Knowledge Management",
    content: "Every document, note, and insight is stored in a centralized, evolving Wiki-style repository. Valiant automatically links related content, tags contributors, and maintains a full audit trail. As your research grows, so does your institutional knowledge—always accessible, always organized."

  },
  {
    key: "text_4",
    title: "Reports in seconds, Not Hours",
    content: "Valiant turns raw research into polished outputs—instantly. Generate executive-ready reports, memos, and email drafts with embedded charts, citations, and intelligent formatting. Save templates and reuse structures so you never start from scratch again."
  },
  {
    key: "text_5",
    title: "Your Workflow, Your Rules",
    content: "Valiant adapts to your process—not the other way around. Organize research by project, client, or outcome. Schedule recurring AI summaries, receive automatic updates, and connect your stack with integrations like Slack, CRMs, and Zapier. It's research, exactly how you want it."

  },
  {
    key: "text_6",
    title: "Trusted Answers, Not AI Guesswork",
    content: "Unlike generic AI tools that rely solely on public models and shallow context, Valiant grounds every response in your team's own research. By combining Retrieval-Augmented Generation (RAG) with your internal documents, notes, and project history, the platform ensures AI outputs are verifiable, transparent, and tied to real sources. Every insight, suggestion, or summary references your actual work—cutting hallucinations and making your AI a trusted extension of your team, not a wildcard."
  },
]

export const Features = () => {
  return (
    <section 
      name="features" 
      className="w-full min-h-screen relative py-24 md:py-16 sm:py-12 px-4 overflow-hidden bg-[#0a192f]"
      style={{ zIndex: 1 }}
    >
      {/* Background image - static */}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: 'url("/birds3.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          opacity: 0.6,
          zIndex: -1,
        }}
      ></div>

      {/* Subtle navy overlay */}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundColor: '#0a192f',
          opacity: 0.5,
          zIndex: -1,
        }}
      ></div>

      <div className="max-w-[1240px] mx-auto relative">
        <div className="mb-16 md:mb-10 sm:mb-6 text-center">
          <h2 className="text-5xl md:text-4xl sm:text-3xl py-1 mb-2 font-bold text-white">
            Key Features
          </h2>
        </div>
        
        <div className="flex flex-col items-center gap-16 md:gap-8 sm:gap-4">
          {featuresArr.map(item => (
            <div 
              className="p-8 md:p-6 sm:p-4 rounded-xl bg-white/10 backdrop-blur-lg border border-white/20 shadow-xl hover:shadow-2xl transition-all duration-500 w-full my-2 sm:my-1" 
              key={item.key}
            >
              <p className="text-3xl md:text-2xl sm:text-xl py-2 md:py-1 text-white font-semibold text-center mb-4 md:mb-2 sm:mb-1">
                {item.title}
              </p>
              <p className="text-xl md:text-lg sm:text-base text-gray-100 mt-2 md:mt-1 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>

        <div className="h-10 md:h-6 sm:h-4"></div> {/* Reduced spacer at the bottom */}
      </div>
    </section>
  );
}

